<template>
    <div class="mx-2 py-3">
        <v-btn class="my-0" small @click="openUploadDocument" color="success"
            >Upload Document</v-btn
        >
        <v-btn
            class="ml-2 my-0"
            small
            @click="openDeleteDcouments"
            v-if="documents.some((d) => d.selected)"
            color="success"
            >Delete Documents</v-btn
        >
        <v-layout row wrap class="">
            <div v-for="uploadedDocument in documents">
                <div
                    class="document mx-2 mt-3"
                    @click="openDocument(uploadedDocument)"
                >
                    <v-layout
                        class="pa-0 ma-0"
                        align-space-between
                        column
                        fill-height
                    >
                        <div
                            class="mb-1 font-weight-medium"
                            style="font-size: 11px"
                        >
                            <input
                                type="checkbox"
                                v-model="uploadedDocument.selected"
                                @click.capture.stop=""
                                class="mr-1"
                                style="width:12px; height:12px; color: rgb(76, 175, 80);"
                            />{{ uploadedDocument.type }}
                        </div>
                        <div
                            class="mb-0 font-weight-light"
                            style="font-size: 12px"
                        >
                            {{ uploadedDocument.uploadedOn | date }}
                        </div>
                        <div
                            class="mb-1 font-weight-regular text-info"
                            style="font-size: 11px"
                        >
                            {{ uploadedDocument.uploadedBy }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-layout
                            class="pa-0 ma-0"
                            row
                            align-end
                            justify-space-between
                        >
                            <div
                                class="font-weight-medium"
                                style="font-size: 11px"
                                :title="uploadedDocument.description"
                            >
                                {{
                                    truncateDescription(
                                        uploadedDocument.description
                                    )
                                }}
                            </div>
                            <v-icon
                                :color="getFileIconColor(uploadedDocument)"
                                >{{ getFileIcon(uploadedDocument) }}</v-icon
                            >
                        </v-layout>

                        <!-- <v-btn
                            small
                            color="warning"
                            @click="deleteDocument(uploadedDocument)"
                            >Delete</v-btn
                        > -->
                    </v-layout>
                </div>
            </div>
        </v-layout>
        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-combobox
                    class="px-3"
                    autocomplete="new-password"
                    :items="documentTypes"
                    label="Type"
                    v-model="uploadDocument.type"
                    ref="documentType"
                ></v-combobox>
                <v-text-field
                    class="px-3"
                    autocomplete="new-password"
                    label="Description"
                    v-model="uploadDocument.description"
                ></v-text-field>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept="image/*,.pdf"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteDocumentsDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline text-warning pl-0"
                    >Are you sure?</v-card-title
                >
                <div class="mb-3">This will delete the selected documents</div>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteDocumentsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteDocuments()"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import {
    formatPhoneNumber,
    formatCurrency,
    truncate,
} from "../utils/helpers.js";
import moment from "moment";

export default {
    props: {
        propertyID: Number,
        property: Object,
        reload: Function,
        documents: Array,
    },
    data() {
        return {
            url: "",
            loading: true,
            processing: false,
            uploading: false,

            uploadDocumentDialog: false,
            deleteDocumentsDialog: false,
            files: [],

            uploadDocument: {
                description: "",
                type: "",
            },

            documentTypes: [],
        };
    },
    async created() {
        await this.loadDocumentTypes();
    },
    watch: {},
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        async loadDocumentTypes() {
            this.documentTypes = await this.$http.get(
                "api/transactions/getDocumentTypes"
            );
        },
        async loadDocuments() {
            const documents = await this.$http.get(
                "api/properties/getDocuments?propertyID=" + this.propertyID
            );

            this.documents = documents.map((doc) => {
                doc.selected = false;

                return doc;
            });
        },
        getDocumentCount() {
            return this.documents.length;
        },
        openDocument(document) {
            window.open(document.url);
        },
        truncateDescription(description) {
            return truncate(description, 20);
        },
        openUploadDocument() {
            this.uploadDocumentDialog = true;
        },
        openDeleteDcouments() {
            this.deleteDocumentsDialog = true;
        },
        closeUploadDocumentDialog() {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        async deleteDocument(document) {
            await this.$http.post(
                "api/transactions/deleteDocument?id=" + document.id
            );

            this.uploadDocumentDialog = false;
            this.reload();
        },
        pickFile() {
            this.$refs.files.click();
        },
        getFileIcon(document) {
            return document.fileName.endsWith("pdf")
                ? "mdi-file-pdf"
                : "mdi-file-image";
        },
        getFileIconColor(document) {
            return document.fileName.endsWith("pdf") ? "red" : "#2196F3";
        },
        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async saveDocument() {
            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("image", this.files[0]);

                await this.$http.post(
                    "api/transactions/uploadDocument?description=" +
                        this.uploadDocument.description +
                        "&type=" +
                        this.uploadDocument.type +
                        "&propertyID=" +
                        this.propertyID +
                        "&user=joel",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteDocuments() {
            this.processing = true;

            try {
                await this.$http.post("api/transactions/deleteDocuments?", {
                    ids: this.documents
                        .filter((d) => d.selected)
                        .map((d) => d.id),
                });

                this.processing = false;
                this.deleteDocumentsDialog = false;
                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.document {
    width: 100px;
    height: 120px;
    border: 1px solid rgb(73 90 99);
    box-shadow: rgb(199 206 216) 3px 3px 1px;
    cursor: pointer;
    border-radius: 1px;
    padding: 6px;
}
</style>
